import type { JSX } from "react";

/**
 * The banknote beside the header's euro-rate vital, drawn as stroke paths in
 * `currentColor` so it inherits the label's colour and scales with the mono
 * text. The label beside it already spells the euro symbol and the code, so this
 * icon says money rather than repeating the currency. Decorative: the rate it
 * sits beside carries the reading for a screen reader.
 */
export function MoneyGlyph(): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="6.8" width="18" height="10.4" rx="2" />
      <circle cx="12" cy="12" r="2.6" />
      <path d="M6.6 10.4v3.2M17.4 10.4v3.2" />
    </svg>
  );
}
